import { Component, Input, OnInit } from '@angular/core';
import { DashboardProvider, OrganizationService } from '../../../services';
import { UserService } from 'src/modules/features/public/services';
import { Router } from '@angular/router';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
@Component({
  selector: 'app-dashboard-company',
  templateUrl: './dashboard-company.component.html',
  styleUrls: ['./dashboard-company.component.scss'],
})
export class DashboardCompanyComponent implements OnInit {
  pending: boolean;
  success: any;
  error: any;
  @Input() companyRecord;
  @Input() companyDetail;
  @Input() isBusinessName;
  @Input() allAffiliateTypes;
  @Input() loading: boolean;
  isVerified: boolean;
  organization;
  records: Array<any> = [
    {
      name: 'RC NUMBER',
      records: 987878,
      date: '18 Nov 2021',
      status: 'Unverified',
    },
    {
      name: 'REGISTRATION DATE',
      records: '18 Nov 2021',
      date: '18 Nov 2021',
      status: 'Unverified',
    },
    {
      name: 'TIN NUMBER ',
      records: '9837687-001',
      date: '18 Nov 2021',
      status: 'Verified',
    },
    {
      name: 'OWNERSHIP TYPE',
      records: 'Nigerian Owned',
      date: '18 Nov 2021',
      status: 'Unverified',
    },
    {
      name: 'COMPANY TYPE',
      records: 'Limited Liability',
      date: '18 Nov 2021',
      status: 'Unverified',
    },
  ];
  status: Object;
  rcStatus: any;
  addressStatus: any;
  tinStatus: any;
  contactStatus: any;
  nameStatus: any;
  docStatus: any;
  shareholders: any;
  directors: any;
  equipmentStatus: any;
  ownershipType;
  constructor(
    private dashboardSvc: DashboardProvider,
    private organizationSvc: OrganizationService,
    private companyOwnershipService: CompanyOwnershipService,
    private userSvc: UserService,
    private router: Router
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.ownershipType = this.organization.jpaContractor.ownershipType.optionId;
  }
  verifyCompany() {
    this.router.navigateByUrl('/contractor/company');
  }

  ngOnInit(): void {}

  getOrganizationDetails() {
    this.organizationSvc
      .getContractor({
        organizationId: this.organization.organizationId,
      })
      .subscribe(
        (res: any) => {
          window.localStorage.setItem('organization', JSON.stringify(res));
          this.organization = res;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getStatusName(nameStatus) {
    if (nameStatus == 'PENDING') return 'PENDING';
    if (
      nameStatus === 'VERIFIED' ||
      (this.companyDetail && this.companyDetail.companyRegVerified)
    ) {
      return 'VERIFIED';
    }
    if (
      nameStatus === 'NOT_AVAILABLE' ||
      (this.companyDetail && !this.companyDetail.companyRegVerified)
    ) {
      return 'NOT AVAILABLE';
    }
    if (nameStatus == 'REJECTED' || nameStatus == 'UNVERIFIED') {
      return 'UNVERIFIED';
    }
  }
  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
      },
      (error) => {
        this.pending = false;
        console.log(error);
      }
    );
  }
  getVerificationStatus() {
    this.pending = true;
    this.dashboardSvc
      .getStatus({
        organizationId: this.organization.organizationId,
      })
      .subscribe(
        (res) => {
          this.status = res;
          this.rcStatus = res['RC_NUMBER'];
          this.addressStatus = res['ADDRESS'];
          this.tinStatus = res['TIN'];
          this.contactStatus = res['CONTACT_INFORMATION'];
          this.nameStatus = res['COMPANY_NAME'];
          this.docStatus = res['OFFICIAL_DOCUMENT'];
          this.shareholders = res['SHAREHOLDER_STRUCTURE'];
          this.directors = res['DIRECTOR_STRUCTURE'];
          this.equipmentStatus = res['EQUIPMENT'];
          this.getOrganizationDetails();
          console.log(this.status, 'status');
        },
        (error) => {
          this.rcStatus = 'NOT_AVAILABLE';
          this.addressStatus = 'NOT_AVAILABLE';
          this.tinStatus = 'NOT_AVAILABLE';
          this.contactStatus = 'NOT_AVAILABLE';
          this.nameStatus = 'NOT_AVAILABLE';
          this.pending = false;
          // this.error = error.error.errorMessage ? error.error.errorMessage
          //                                       : error.error ? error.error
          //                                       : error;
        }
      );
  }
  personnelStructureKeys = [];
  companyAffiliateTypes!: any[];

  getAffiliateTypeVerificationStatus() {
    if (this.personnelStructureKeys && this.companyAffiliateTypes?.length) {
      this.companyAffiliateTypes.forEach((affiliateType) => {
        let statusKey = this.personnelStructureKeys.find((key) => {
          return key
            .toLowerCase()
            .includes(affiliateType.ownershipType.toLowerCase());
        });
        affiliateType.status = statusKey ? this.status[statusKey] : '';
      });
    }
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.companyAffiliateTypes = res;
          console.log(this.companyAffiliateTypes, 'this.companyAffiliateTypes');
          this.getAffiliateTypeVerificationStatus();
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
